import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const TitleWrapper = styled.div`
  background: ${props => props.theme.palette.primary.alphaDark} !important;
  border-radius: 0 !important;
 
  > div {
    padding: 60px !important;
    ${bp('sm')`
      padding: 20px !important;
    `}
  }

  h1 {
    margin: 0;
    text-align: center;
    font-size: 100px;
    ${bp('sm')`
      font-size: 72px;
      padding: 15px 0;
    `}
  }
`

export const ContentWrapper = styled.div`
  background: ${props => props.theme.palette.primary.alphaDark};
  min-height: 400px;
  padding: 60px 80px !important;
  text-align: center;
  ${bp('sm')`
    padding: 30px 15px !important;
  `}

  h2 {
    margin: 0;
    text-transform: none;
    color: ${props => props.theme.palette.primary.alphaDark};
    font-weight: 500;
  }

  p {
    color: ${props => props.theme.palette.primary.alphaDark};
    font: ${font('default', 'normal', '22px/1.4')};
    letter-spacing: 1px;
    margin-bottom: 30px;
    ${bp('sm')`
      font: ${font('default', 'normal', '12px/1.2')};
    `}
  }

  .button {
    border-radius: 5px;
    background: ${props => props.theme.palette.primary.beta};
    margin: auto;
    box-shadow: 0 2px 12px -4px rgba(0, 0, 0, 0.75);
    ${bp('sm')`
      max-width: 200px;
    `}

    > div {
      padding: 10px 30px;
    }

    p {
      font: ${font('default', 'bold', '18px/1.4')};
      text-transform: uppercase;
      letter-spacing: 1px;
      color: ${props => props.theme.palette.general.light};
      margin: 0;
      ${bp('sm')`
        font: ${font('default', 'bold', '12px/1.2')};
      `}
    }
  }
`
